var map = {
	"./Messages.jpg": 309,
	"./Messages.png": 119,
	"./book.png": 120,
	"./box.png": 121,
	"./chat.png": 122,
	"./chat_01.png": 310,
	"./chat_02.png": 311,
	"./chat_icon.png": 312,
	"./cloud.png": 123,
	"./dashboard.png": 313,
	"./dot.png": 314,
	"./get_started_bg.png": 315,
	"./john.png": 124,
	"./left_leaf.png": 125,
	"./live_chat.png": 126,
	"./mobile.png": 127,
	"./panguin_img_one.png": 128,
	"./panguin_img_three.png": 129,
	"./panguin_img_two.png": 130,
	"./pluse.png": 131,
	"./richard.png": 132,
	"./right_leaf.png": 133,
	"./skyp_1.png": 316,
	"./skyp_2.png": 317,
	"./support_dashboard.jpg": 318,
	"./triangle.png": 134,
	"./video_icon.png": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;